import { Box, Fade, Typography } from '@mui/material'
import BottomLeft0 from 'assets/images/for-artists/hero/bottom-left-0.webp'
import BottomLeft1 from 'assets/images/for-artists/hero/bottom-left-1.webp'
import BottomLeft2 from 'assets/images/for-artists/hero/bottom-left-2.webp'
import BottomLeft3 from 'assets/images/for-artists/hero/bottom-left-3.webp'
import BottomLeft4 from 'assets/images/for-artists/hero/bottom-left-4.webp'
import BottomRight0 from 'assets/images/for-artists/hero/bottom-right-0.webp'
import BottomRight1 from 'assets/images/for-artists/hero/bottom-right-1.webp'
import BottomRight2 from 'assets/images/for-artists/hero/bottom-right-2.webp'
import BottomRight3 from 'assets/images/for-artists/hero/bottom-right-3.webp'
import BottomRight4 from 'assets/images/for-artists/hero/bottom-right-4.webp'
import MainImg from 'assets/images/for-artists/hero/main.webp'
import Right0 from 'assets/images/for-artists/hero/right-0.webp'
import Right1 from 'assets/images/for-artists/hero/right-1.webp'
import Right2 from 'assets/images/for-artists/hero/right-2.webp'
import Right3 from 'assets/images/for-artists/hero/right-3.webp'
import Right4 from 'assets/images/for-artists/hero/right-4.webp'
import TopLeft0 from 'assets/images/for-artists/hero/top-left-0.webp'
import TopLeft1 from 'assets/images/for-artists/hero/top-left-1.webp'
import TopLeft2 from 'assets/images/for-artists/hero/top-left-2.webp'
import TopLeft3 from 'assets/images/for-artists/hero/top-left-3.webp'
import TopLeft4 from 'assets/images/for-artists/hero/top-left-4.webp'
import TopRight0 from 'assets/images/for-artists/hero/top-right-0.webp'
import TopRight1 from 'assets/images/for-artists/hero/top-right-1.webp'
import TopRight2 from 'assets/images/for-artists/hero/top-right-2.webp'
import TopRight3 from 'assets/images/for-artists/hero/top-right-3.webp'
import TopRight4 from 'assets/images/for-artists/hero/top-right-4.webp'
import { useEffect, useState } from 'react'
const topLeftImages = [TopLeft0, TopLeft1, TopLeft2, TopLeft3, TopLeft4]
const topRightImages = [TopRight0, TopRight1, TopRight2, TopRight3, TopRight4]
const rightImages = [Right0, Right1, Right2, Right3, Right4]
const bottomRightImages = [
  BottomRight0,
  BottomRight1,
  BottomRight2,
  BottomRight3,
  BottomRight4,
]
const bottomLeftImages = [
  BottomLeft0,
  BottomLeft1,
  BottomLeft2,
  BottomLeft3,
  BottomLeft4,
]

const textContent = [
  {
    content: 'Create your profile in mins',
    style: { top: '40%', left: '2%' },
  },
  { content: 'Customers discover you', style: { bottom: '20%', left: '40%' } },
  {
    content: 'Create your own booking process',
    style: { top: '20%', left: '40%' },
  },
  { content: 'Sell your flash tattoos', style: { top: '40%', left: '2%' } },
  {
    content: 'Deposit and multiple payment methods',
    style: { bottom: '20%', left: '30%' },
  },
]

const HeroAnimation = () => {
  const [step, setStep] = useState(0)
  useEffect(() => {
    const interval = setInterval(() => {
      if (step < topLeftImages.length - 1) {
        setStep(step + 1)
      } else {
        setStep(0)
      }
    }, 3800)

    return () => {
      clearInterval(interval)
    }
  }, [step])
  return (
    <Box sx={{ position: 'relative', height: '100%', maxHeight: '700px' }}>
      <Box>
        {topLeftImages.map((image, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ position: 'relative' }}
              enter
              exit
              easing={{ enter: 'ease-out', exit: 'ease-out' }}
              timeout={{ appear: 2000, enter: 1000, exit: 2000 }}
            >
              <img
                src={image.src}
                style={{
                  width: '20%',
                  position: 'absolute',
                  left: '18%',
                  top: '18%',
                  //   filter: 'saturate(60%)',
                  filter: 'blur(0.5px)',
                }}
              />
            </Fade>
          )
        })}
      </Box>
      <Box>
        {topRightImages.map((image, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ position: 'relative' }}
              enter
              exit
              easing={{ enter: 'ease-out', exit: 'ease-out' }}
              timeout={{ appear: 2000, enter: 1000, exit: 2000 }}
            >
              <img
                src={image.src}
                style={{
                  width: '20%',
                  position: 'absolute',
                  right: '18%',
                  top: '12%',
                  //   filter: 'saturate(0.9)',
                  filter: 'blur(0.3px)',
                }}
              />
            </Fade>
          )
        })}
      </Box>
      <Box>
        {bottomRightImages.map((image, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ position: 'relative' }}
              enter
              exit
              easing={{ enter: 'ease-out', exit: 'ease-out' }}
              timeout={{ appear: 2000, enter: 1000, exit: 2000 }}
            >
              <img
                src={image.src}
                style={{
                  width: '25%',
                  position: 'absolute',
                  right: '8%',
                  bottom: '18%',
                  //   filter: 'saturate(60%)',
                  filter: 'blur(0.5px)',
                }}
              />
            </Fade>
          )
        })}
      </Box>
      <Box>
        {rightImages.map((image, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ position: 'relative' }}
              enter
              exit
              easing={{ enter: 'ease-out', exit: 'ease-out' }}
              timeout={{ appear: 2000, enter: 1000, exit: 2000 }}
            >
              <img
                src={image.src}
                style={{
                  width: '18%',
                  position: 'absolute',
                  right: '0',
                  bottom: '45%',
                  boxShadow: '-2px 2px 12px -4px #424242',
                  borderRadius: '20px',
                }}
              />
            </Fade>
          )
        })}
      </Box>
      <Box>
        {bottomLeftImages.map((image, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ position: 'relative' }}
              enter
              exit
              easing={{ enter: 'ease-out', exit: 'ease-out' }}
              timeout={{ appear: 2000, enter: 1000, exit: 2000 }}
            >
              <img
                src={image.src}
                style={{
                  width: '22%',
                  position: 'absolute',
                  left: '18%',
                  bottom: '15%',
                  //   filter: 'saturate(60%)',
                  filter: 'blur(0.6px)',
                }}
              />
            </Fade>
          )
        })}
      </Box>
      <Box>
        <img
          src={MainImg.src}
          style={{
            width: '35%',
            boxShadow: '2px 2px 12px -4px #424242',
            borderRadius: '20px',
            position: 'absolute',
            top: '25%',
            left: '35%',
          }}
        />
      </Box>
      <Box sx={{ height: '100%' }}>
        {textContent.map((element, idx) => {
          return (
            <Fade
              key={`animation-top-left-${idx}`}
              in={step === idx}
              style={{ zIndex: '100' }}
              enter
              exit
              easing={{ enter: 'ease-in', exit: 'ease-out' }}
              timeout={{ appear: 0, enter: 1000, exit: 2000 }}
            >
              <Box sx={{ height: '100%' }}>
                <Typography
                  sx={{
                    backgroundColor: ' white',
                    width: 'fit-content',
                    padding: '0.5rem 1.5rem',
                    borderRadius: '100px',
                    position: 'absolute',
                    fontWeight: 600,
                    fontSize: '1rem',
                    ...element.style,
                  }}
                >
                  {element.content}
                </Typography>
              </Box>
            </Fade>
          )
        })}
      </Box>
    </Box>
  )
}

export default HeroAnimation
